module.exports = __webpack_public_path__ + "img/1.23aac1f2.jpg";